import { render, staticRenderFns } from "./ReviewAndSubmit.vue?vue&type=template&id=b609741e&scoped=true"
import script from "./ReviewAndSubmit.vue?vue&type=script&lang=ts"
export * from "./ReviewAndSubmit.vue?vue&type=script&lang=ts"
import style0 from "./ReviewAndSubmit.vue?vue&type=style&index=0&id=b609741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b609741e",
  null
  
)

export default component.exports